import './tabs/twrp-tab.ts';
import './main-framework/twrp-show-more';
import './article-blocks/article-blocks';

export default {};
